import React, { useContext } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { S as ShippingChart } from './ShippingChart-WhG8PR2C.js';
import { B as BedShippingChart } from './BedShippingChart-5Mamjyyj.js';
import { CoreContext } from './context/index.js';
import { a as LanguageCode } from './language-BHHwgtQp.js';

const Content = ({ pageContent, shippingData, bedShippingCountries, bedShippingValues, }) => {
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { data: { siteConfig: { noZeroAfterDecimal = false }, }, } = useContext(CoreContext);
    const router = useRouter();
    const locale = router ? router.locale : LanguageCode.En;
    const shippingCartHtml = shippingData
        ? renderToStaticMarkup(React.createElement(ShippingChart, { shippingData: JSON.parse(shippingData.content).data, currency: JSON.parse(shippingData.content).currency.toUpperCase(), locale: locale, noZeroAfterDecimal: noZeroAfterDecimal, andMore: tCommon('andMore') }))
        : '';
    const bedShippingChartHtml = bedShippingCountries && bedShippingValues
        ? renderToStaticMarkup(React.createElement(BedShippingChart, { bedShippingValues: JSON.parse(bedShippingValues.content).data, bedShippingCountries: JSON.parse(bedShippingCountries.content).data, currency: JSON.parse(bedShippingValues.content).currency.toUpperCase(), locale: locale, noZeroAfterDecimal: noZeroAfterDecimal, country: tLabel('country'), fees: tLabel('fees') }))
        : '';
    let content = (pageContent === null || pageContent === void 0 ? void 0 : pageContent.content) || '';
    content = content
        .replace('<div id="shipping-table-container"></div>', `<div id="shipping-table-container">${shippingCartHtml}</div>`)
        .replace('<div id="bed-table-container"></div>', `<div id="bed-table-container">${bedShippingChartHtml}</div>`);
    return React.createElement("div", { className: "content faq", dangerouslySetInnerHTML: { __html: content } });
};

export { Content as C };
//# sourceMappingURL=Content-7EOS_2d5.js.map
